import formatErrorMessage from "../../../utils/formatErrorMessage.js";
import * as React from "react";
const TooltipPortalContext = /* @__PURE__ */ React.createContext(void 0);
if (process.env.NODE_ENV !== "production") TooltipPortalContext.displayName = "TooltipPortalContext";
function useTooltipPortalContext() {
  const value = React.useContext(TooltipPortalContext);
  if (value === void 0) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Tooltip.Portal> is missing." : formatErrorMessage(70));
  }
  return value;
}
export {
  TooltipPortalContext,
  useTooltipPortalContext
};
//# sourceMappingURL=TooltipPortalContext.js.map
